__turbopack_context__.v({
  "divider": "menu-module-scss-module__JL2g6G__divider",
  "dropdownContent": "menu-module-scss-module__JL2g6G__dropdownContent",
});
